import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import swal from "sweetalert";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MUIDataTable from "mui-datatables";
import EditIcon from "@material-ui/icons/Edit";
import { API_URL } from "../../config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Link } from "react-router-dom";
import Barcode from "react-barcode";
import PrintIcon from "@material-ui/icons/Print";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import HorizontalSplitIcon from "@material-ui/icons/HorizontalSplit";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { pathSpliter, checkAuthBranchWare, sortRecordsNewestFirst } from "../../lib/functions";
import {
  currentRouteSet,
  updatedProductSet,
  disableRestoreProductSet,
  createdProductSet,
  createdUnitSet,
  updatedUnitSet,
} from "../../actions/actions";

const ProductsManage = ({
  location,
  currentRouteSet,
  authInfo,
  createdProdName,
  updatedProdName,
  prodNameDisableRestoreAction,
  createdCategory,
  updatedCategory,
  createBrand,
  updateBrand,
  createdColor,
  updatedColor,
  createdProduct,
  updatedProduct,
  productCodeGet,
  productDisableRestoreAction,
  updatedProductSet,
  disableRestoreProductSet,
  createdProductSet,
  createdUnit,
  updatedUnit,
  createdUnitSet,
  updatedUnitSet,
}) => {
  const classes = useStyles();

  // Modal states
  const [catM, catMSet] = useState(false);
  const [colorM, colorMSet] = useState(false);
  const [brandM, brandMSet] = useState(false);
  const [prodM, prodMSet] = useState(false);
  const [unitM, unitMSet] = useState(false);
  const [barcodeModal, setBarcodeModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);

  // Action loading states
  const [catAction, catActionSet] = useState(false);
  const [brandAction, brandActionSet] = useState(false);
  const [colorAction, colorActionSet] = useState(false);
  const [prodNameAction, prodNameActionSet] = useState(false);
  const [unitAction, unitActionSet] = useState(false);

  // Form states
  const [loadingSave, loadingSaveSet] = useState(false);
  const [loadingList, loadingListSet] = useState(false);
  const [loadingBranchSend, loadingBranchSendSet] = useState(false);
  const [productListError, productListErrorSet] = useState("");
  const [productUpdateIndex, productUpdateIndexSet] = useState("0");
  const [productCode, productCodeSet] = useState("");
  const [prod_id, prod_id_set] = useState(0);
  const [prod_re_order_lebel, prod_re_order_lebel_set] = useState(0);
  const [prod_is_service, prod_is_service_set] = useState(false);

  // Data states
  const [products, productsSet] = useState([]);
  const [categories, categoriesSet] = useState([]);
  const [branches, branchesSet] = useState([]);
  const [brands, brandsSet] = useState([]);
  const [colors, colorsSet] = useState([]);
  const [units, unitsSet] = useState([]);
  const [prodNames, prodNamesSet] = useState([]);

  // Selected states
  const [selectedCategory, selectedCategorySet] = useState(null);
  const [selectedBranch, selectedBranchSet] = useState(null);
  const [selectedBrand, selectedBrandSet] = useState(null);
  const [selectedColor, selectedColorSet] = useState(null);
  const [selectedUnit, selectedUnitSet] = useState(null);
  const [selectedProdName, selectedProdNameSet] = useState(null);
  const [selectedProductRows, selectedProductRowsSet] = useState([]);
  const [selectedProductIndexes, selectedProductIndexesSet] = useState([]);
  const [productTableKey, productTableKeySet] = useState(0);

  // Input states for modals
  const [action, actionSet] = useState("create");
  const [prod_cat_name, prod_cat_name_set] = useState("");
  const [prod_brand_name, prod_brand_name_set] = useState("");
  const [prod_color_name, prod_color_name_set] = useState("");
  const [prod_name, prod_name_set] = useState("");
  const [prod_unit_name, prod_unit_name_set] = useState("");

  // Refs
  const catRef = React.useRef(null);
  const brandRef = React.useRef(null);
  const colorRef = React.useRef(null);
  const prodNameRef = React.useRef(null);
  const unitNameRef = React.useRef(null);
  const reOrderLevelRef = React.useRef(null);
  const saveFormActionRef = React.useRef(null);



  const [successMsg, setSuccessMsg] = useState({
    open: false,
    msg: "",
  });
  const isMainBranchUser =
    String(authInfo?.userInfo?.user_branch_id) === "1" ||
    String(authInfo?.userInfo?.branch_name || "").trim().toLowerCase() === "deshit-bd";

  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };

  const handleBarcodeModalOpen = () => {
    setBarcodeModal(true);
    setSelectedProducts(products.filter(product => product.prod_status === "active"));
  };

  const handleBarcodeModalClose = () => {
    setBarcodeModal(false);
  };

  const saveUnitAction = async () => {
    if (prod_unit_name.trim() === "") {
      swal({ title: "Unit name is required", icon: "warning" });
      return;
    }

    try {
      unitActionSet(true);

      const res = await axios.post(
        `${API_URL}/api/unit-cu`,
        {
          prod_unit_name: prod_unit_name.trim(),
          action: "create",
        },
        {
          headers: { "auth-token": authInfo.token },
        }
      );

      unitActionSet(false);

      if (res.data?.error) {
        swal({ title: res.data.message, icon: "warning" });
        return;
      }

      // close modal
      unitMSet(false);

      // clear input
      prod_unit_name_set("");

      // reload unit dropdown
      getUnits();

    } catch (err) {
      unitActionSet(false);
      swal({
        title: "Failed to save unit",
        text: err.response?.data?.message || err.message,
        icon: "error",
      });
    }
  };


  const downloadBarcodes = () => {
    const input = document.getElementById("barcode-container");
    html2canvas(input, {
      scale: 2,
      logging: false,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save("product-barcodes.pdf");
    });
  };

  const printBarcodes = () => {
    const input = document.getElementById("barcode-container");
    html2canvas(input, {
      scale: 2,
      logging: false,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const windowContent = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Print Barcodes</title>
            <style>
              body { margin: 0; padding: 0; }
              img { width: 100%; height: auto; }
            </style>
          </head>
          <body>
            <img src="${imgData}" onload="window.print();window.close()" />
          </body>
        </html>
      `;
      const printWin = window.open("", "", "width=800,height=600");
      printWin.document.open();
      printWin.document.write(windowContent);
      printWin.document.close();
    });
  };

  const normalizeProductsWithUnits = (rows, availableUnits = units) => {
    if (!Array.isArray(rows)) {
      return [];
    }

    return rows.map((row) => {
      if (!row || row.prod_unit_name) {
        return row;
      }

      const matchedUnit = availableUnits.find(
        (unit) => String(unit?.prod_unit_id) === String(row?.prod_unit_id)
      );

      return matchedUnit
        ? { ...row, prod_unit_name: matchedUnit.prod_unit_name }
        : row;
    });
  };

  const sortProductsForList = (rows, options = {}) => {
    const normalizedRows = normalizeProductsWithUnits(rows, options.availableUnits || units);
    const visibleRows = normalizedRows.filter(
      (row) => String(row?.prod_status || "").toLowerCase() !== "deleted"
    );

    const getStatusRank = (status) => {
      const normalizedStatus = String(status || "").toLowerCase();
      if (normalizedStatus === "active") return 0;
      if (normalizedStatus === "deactivated") return 1;
      return 2;
    };

    const getRecentId = (row) => {
      const id = parseInt(row?.prod_id, 10);
      return Number.isFinite(id) ? id : 0;
    };

    return [...visibleRows].sort((left, right) => {
      const rankDiff = getStatusRank(left?.prod_status) - getStatusRank(right?.prod_status);
      if (rankDiff !== 0) return rankDiff;
      return getRecentId(right) - getRecentId(left);
    });
  };

  const refreshProducts = () => {
    productListErrorSet("");
    loadingListSet(true);
    loadProductsFallback();
  };

  const loadProductsFallback = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-products`,
        null,
        { headers: { "auth-token": authInfo.token } }
      );
      loadingListSet(false);
      productListErrorSet("");
      productsSet(sortProductsForList(Array.isArray(res?.data?.message) ? res.data.message : []));
      return true;
    } catch (err) {
      loadingListSet(false);
      productListErrorSet(
        err?.response?.data?.message ||
        err?.message ||
        "Product list load করা যায়নি।"
      );
      return false;
    }
  };

  useEffect(() => {
    updatedProductSet(null);
    disableRestoreProductSet(null);
    createdProductSet(null);
    createdUnitSet(null);
    updatedUnitSet(null);
    getProdCode();
    currentRouteSet(pathSpliter(location.pathname, 1));
    getCategories();
    getBranches();
    getBrands();
    getColors();
    getUnits();
    getProdNames();
    refreshProducts();

    return () => {
    };
  }, []);

  useEffect(() => {
    if (units.length > 0 && products.length > 0) {
      productsSet((prev) => sortProductsForList(prev, { availableUnits: units }));
    }
  }, [units]);

  const getCategories = async () => {
    await axios
      .post(
        `${API_URL}/api/get-categories`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        categoriesSet(res.data.message);
      });
  };

  const getBrands = async () => {
    await axios
      .post(
        `${API_URL}/api/get-brands`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        brandsSet(res.data.message);
      });
  };

  const getBranches = async () => {
    await axios
      .post(
        `${API_URL}/api/get-branches`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        const currentBranchId = authInfo?.userInfo?.user_branch_id;
        const availableBranches = (res.data.message || []).filter(
          (branch) => String(branch.branch_id) !== String(currentBranchId)
        );
        branchesSet(availableBranches);
      });
  };

  const getColors = async () => {
    await axios
      .post(
        `${API_URL}/api/get-colors`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        colorsSet(res.data.message);
      });
  };

  const getUnits = async () => {
    await axios
      .post(
        `${API_URL}/api/get-units`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        unitsSet(res.data.message);
      });
  };



  const getProdCode = async () => {
    await axios
      .get(`${API_URL}/api/get-product-code`, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        productCodeSet(res.data.message);
      });
  };

  const getProdNames = async () => {
    await axios
      .post(
        `${API_URL}/api/get-prod-names`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        prodNamesSet(res.data.message);
      });
  };



  const saveProdAction = async () => {
    if (prod_name.trim() == "") {
      swal({ title: "Product name is required", icon: "warning" });
    } else {
      prodNameActionSet(true);
      await axios
        .post(
          `${API_URL}/api/prod-name-cu`,
          { prod_name: prod_name.trim(), action: "create" },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          prodNameActionSet(false);
          if (res.data.error) {
            swal({ title: res.data.message, icon: "warning" });
            return false;
          }
          prodMSet(false);
          prod_name_set("");
          getProdNames();
        });
    }
  };

  const saveCateAction = async () => {
    if (prod_cat_name.trim() == "") {
      swal({ title: "Category name is required", icon: "warning" });
    } else {
      catActionSet(true);
      await axios
        .post(
          `${API_URL}/api/category-cu`,
          { prod_cat_name: prod_cat_name.trim(), action: "create" },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          catActionSet(false);
          if (res.data.error) {
            swal({ title: res.data.message, icon: "warning" });
            return false;
          }
          catMSet(false);
          prod_cat_name_set("");
          getCategories();
        });
    }
  };

  const saveBrandAction = async () => {
    if (prod_brand_name.trim() == "") {
      swal({ title: "Brand name is required", icon: "warning" });
    } else {
      brandActionSet(true);
      await axios
        .post(
          `${API_URL}/api/brand-cu`,
          { prod_brand_name: prod_brand_name.trim(), action: "create" },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          brandActionSet(false);
          if (res.data.error) {
            swal({ title: res.data.message, icon: "warning" });
            return false;
          }
          brandMSet(false);
          prod_brand_name_set("");
          getBrands();
        });
    }
  };

  const saveColorAction = async () => {
    if (prod_color_name.trim() == "") {
      swal({ title: "Country name is required", icon: "warning" });
    } else {
      colorActionSet(true);
      await axios
        .post(
          `${API_URL}/api/color-cu`,
          { prod_color_name: prod_color_name.trim(), action: "create" },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          colorActionSet(false);
          if (res.data.error) {
            swal({ title: res.data.message, icon: "warning" });
            return false;
          }
          colorMSet(false);
          prod_color_name_set("");
          getColors();
        });
    }
  };

  // Real-time updates
  useEffect(() => {
    if (createdCategory && checkAuthBranchWare(createdCategory.user_branch_id)) {
      categoriesSet(sortRecordsNewestFirst(createdCategory.createdRow.concat(categories)));
    }
  }, [createdCategory]);

  useEffect(() => {
    if (updatedCategory && checkAuthBranchWare(updatedCategory.user_branch_id)) {
      categories[updatedCategory.index] = updatedCategory.updatedRow[0];
    }
  }, [updatedCategory]);

  useEffect(() => {
    if (createBrand && checkAuthBranchWare(createBrand.user_branch_id)) {
      brandsSet(sortRecordsNewestFirst(createBrand.createdRow.concat(brands)));
    }
  }, [createBrand]);

  useEffect(() => {
    if (updateBrand && checkAuthBranchWare(updateBrand.user_branch_id)) {
      brands[updateBrand.index] = updateBrand.updatedRow[0];
    }
  }, [updateBrand]);

  useEffect(() => {
    if (createdColor && checkAuthBranchWare(createdColor.user_branch_id)) {
      colorsSet(sortRecordsNewestFirst(createdColor.createdRow.concat(colors)));
    }
  }, [createdColor]);

  useEffect(() => {
    if (updatedColor && checkAuthBranchWare(updatedColor.user_branch_id)) {
      colors[updatedColor.index] = updatedColor.updatedRow[0];
    }
  }, [updatedColor]);


  useEffect(() => {
    if (createdUnit && checkAuthBranchWare(createdUnit.user_branch_id)) {
      unitsSet(sortRecordsNewestFirst(createdUnit.createdRow.concat(units)));
    }
  }, [createdUnit]);

  useEffect(() => {
    if (updatedUnit && checkAuthBranchWare(updatedUnit.user_branch_id)) {
      units[updatedUnit.index] = updatedUnit.updatedRow[0];
    }
  }, [updatedUnit]);



  useEffect(() => {
    if (createdProdName && checkAuthBranchWare(createdProdName.user_branch_id)) {
      prodNamesSet(sortRecordsNewestFirst(createdProdName.createdRow.concat(prodNames)));
      setSuccessMsg({ ...successMsg, msg: createdProdName.msg, open: true });
    }
  }, [createdProdName]);

  useEffect(() => {
    if (updatedProdName && checkAuthBranchWare(updatedProdName.user_branch_id)) {
      prodNames[updatedProdName.index] = updatedProdName.updatedRow[0];
      setSuccessMsg({ ...successMsg, msg: updatedProdName.msg, open: true });
    }
  }, [updatedProdName]);

  useEffect(() => {
    if (createdProduct && checkAuthBranchWare(createdProduct.user_branch_id)) {
      productsSet(sortProductsForList(createdProduct.createdRow.concat(products)));
      setSuccessMsg({ ...successMsg, msg: createdProduct.msg, open: true });
    }
  }, [createdProduct]);

  useEffect(() => {
    if (updatedProduct && checkAuthBranchWare(updatedProduct.user_branch_id)) {
      if (products.length > updatedProduct.index) {
        const newProducts = [...products];
        newProducts[updatedProduct.index] = updatedProduct.updatedRow[0];
        productsSet(sortProductsForList(newProducts));
      }
      setSuccessMsg({ ...successMsg, msg: updatedProduct.msg, open: true });
      getProdCode();
    }
  }, [updatedProduct, products]);

  useEffect(() => {
    if (productCodeGet && action == "create") {
      getProdCode();
    }
  }, [productCodeGet]);

  useEffect(() => {
    if (productDisableRestoreAction && checkAuthBranchWare(productDisableRestoreAction.user_branch_id)) {
      if (products.length > productDisableRestoreAction.index) {
        const newProducts = [...products];
        newProducts[productDisableRestoreAction.index] = productDisableRestoreAction.disableRestoreRow[0];
        productsSet(sortProductsForList(newProducts));
      }
      setSuccessMsg({ ...successMsg, msg: productDisableRestoreAction.msg, open: true });
    }
  }, [productDisableRestoreAction, products]);

  const saveFormAction = async () => {
    if (!selectedCategory) {
      swal({ title: "Select a product category", icon: "warning" });
      return;
    }
    if (!selectedBrand) {
      swal({ title: "Select a brand name", icon: "warning" });
      return;
    }
    if (!selectedColor) {
      swal({ title: "Select a country name", icon: "warning" });
      return;
    }
    if (!selectedProdName) {
      swal({ title: "Select a product name", icon: "warning" });
      return;
    }
    if (!selectedUnit) {
      swal({ title: "Select a Unit Name", icon: "warning" });
      return;
    }

    try {
      loadingSaveSet(true);

      const response = await axios.post(`${API_URL}/api/product-cu`, {
        prod_id,
        prod_code: productCode,
        productUpdateIndex,
        prod_cat_id: selectedCategory.prod_cat_id,
        prod_brand_id: selectedBrand.prod_brand_id,
        prod_color_id: selectedColor.prod_color_id,
        prod_name_id: selectedProdName.prod_name_id,
        prod_unit_id: selectedUnit.prod_unit_id || null,
        prod_unit_name: selectedUnit.prod_unit_name,
        prod_is_service: prod_is_service ? "true" : "false",
        action,
        prod_re_order_lebel: prod_re_order_lebel || 0,
      }, {
        headers: { 'auth-token': authInfo.token }
      });

      loadingSaveSet(false);

      if (response.data.warning) {
        swal({ title: response.data.message, icon: "warning" });
        return;
      }

      resetFormFields();
      refreshProducts(); // Refresh the products list immediately
      setSuccessMsg({
        ...successMsg,
        msg: action === "create" ? "Product created successfully!" : "Product updated successfully!",
        open: true,
      });

    } catch (error) {
      loadingSaveSet(false);
      swal({
        title: "Error saving product",
        text: error.response?.data?.message || error.message,
        icon: "error",
      });
    }

    if (catRef.current) {
      catRef.current.focus();
    }
  };

  const resetFormFields = () => {
    selectedCategorySet(null);
    selectedBrandSet(null);
    selectedColorSet(null);
    selectedColorSet(null);
    selectedUnitSet(null);
    selectedProdNameSet(null);
    prod_unit_name_set("");
    selectedProdNameSet(null);
    prod_is_service_set(false);
    prod_re_order_lebel_set("");
    actionSet("create");
    getProdCode();
  };

  const productEdit = (row) => {
    const rowProdId = row?.[0];
    const prod = products.find((p) => String(p.prod_id) === String(rowProdId));
    if (!prod) {
      swal({ title: "Selected product not found", icon: "warning" });
      return;
    }
    selectedCategorySet({
      prod_cat_id: prod.prod_cat_id,
      prod_cat_name: prod.prod_cat_name,
    });

    selectedBrandSet({
      prod_brand_id: prod.prod_brand_id,
      prod_brand_name: prod.prod_brand_name,
    });
    selectedColorSet({
      prod_color_id: prod.prod_color_id,
      prod_color_name: prod.prod_color_name,
    });

    // Find unit
    let unit = units.find(u => u.prod_unit_name === prod.prod_unit_name);
    if (unit) {
      selectedUnitSet(unit);
    } else {
      selectedUnitSet({ prod_unit_name: prod.prod_unit_name, prod_unit_id: 0 }); // Fallback if unit not found in list but exists in product
    }

    prod_unit_name_set(prod.prod_unit_name || "");

    selectedProdNameSet({
      prod_name_id: prod.prod_name_id,
      prod_name: prod.prod_name,
    });
    productCodeSet(prod.prod_code);
    productUpdateIndexSet(products.findIndex((p) => String(p.prod_id) === String(prod.prod_id)));
    prod_is_service_set(prod.prod_is_service == "false" ? false : true);
    prod_re_order_lebel_set(prod.prod_re_order_lebel);
    prod_id_set(prod.prod_id);
    actionSet("update");
  };

  const productDisableRestore = async (productId, actionCond, index) => {
    if (actionCond === "delete") {
      const willDelete = await swal({
        title: "Are you sure?",
        text: "Do you want to permanently delete this product?",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      });

      if (!willDelete) return;
    }

    try {
      await axios.post(
        `${API_URL}/api/product-disable-restore`,
        {
          prod_id: productId,
          product_id: productId,
          productId,
          action: actionCond,
          actionCond,
          actionAlias: actionCond === "delete" ? "x" : "a",
          index,
        },
        { headers: { "auth-token": authInfo.token } }
      );

      if (actionCond === "delete") {
        productsSet((prev) =>
          sortProductsForList(prev.filter((p) => String(p.prod_id) !== String(productId)))
        );
      } else {
        productsSet((prev) =>
          sortProductsForList(prev.map((p) =>
            String(p.prod_id) === String(productId)
              ? { ...p, prod_status: "active" }
              : p
          ))
        );
      }
    } catch (err) {
      swal({
        title: "Action failed",
        text: err?.response?.data?.message || err?.message || "Request failed",
        icon: "error",
      });
    }
  };

  const sendSelectedProductsToBranch = async () => {
    if (!isMainBranchUser) {
      swal({ title: "Only main branch can send products", icon: "warning" });
      return;
    }

    if (!selectedProductRows.length) {
      swal({ title: "Select at least one product", icon: "warning" });
      return;
    }

    if (!selectedBranch) {
      swal({ title: "Select a branch", icon: "warning" });
      return;
    }

    const confirmSend = await swal({
      title: "Send selected products?",
      text: `Branch: ${selectedBranch.branch_name}\nSelected: ${selectedProductRows.length} product(s)`,
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (!confirmSend) return;

    try {
      loadingBranchSendSet(true);
      const res = await axios.post(
        `${API_URL}/api/product-send-to-branch`,
        {
          branch_id: selectedBranch.branch_id,
          product_ids: selectedProductRows.map((row) => row.prod_id),
        },
        { headers: { "auth-token": authInfo.token } }
      );

      loadingBranchSendSet(false);

      if (res.data?.error) {
        swal({ title: res.data.message || "Failed to send products", icon: "error" });
        return;
      }

      selectedProductRowsSet([]);
      selectedProductIndexesSet([]);
      productTableKeySet((prev) => prev + 1);
      selectedBranchSet(null);
      swal({ title: res.data.message || "Products sent successfully", icon: "success" });
    } catch (error) {
      loadingBranchSendSet(false);
      swal({
        title: "Failed to send products",
        text: error.response?.data?.message || error.message,
        icon: "error",
      });
    }
  };

  const ActionOptions = (props) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
        {authInfo.role != "user" && (
          <>
            <Link to={{ pathname: `/administration/product-barcode/${props.rowData[0]}` }}>
              <HorizontalSplitIcon style={{ cursor: "pointer", color: "#222", fontSize: "28px" }} />
            </Link>
            <EditIcon
              style={{ cursor: "pointer", fontSize: "28px", color: "rgb(15, 126, 119)" }}
              onClick={() => productEdit(props.rowData)}
            />
            <DeleteIcon
              style={{ cursor: "pointer", color: "#ff0202", fontSize: "28px" }}
              onClick={() =>
                productDisableRestore(props.rowData[0], "delete", props.rowIndex)
              }
            />
          </>
        )}
      </div>
    );
  };

  const columns = [
    { name: "prod_id", options: { display: "excluded" } },
    {
      name: "prod_status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const status = String(value || "").toLowerCase();
          const isActive = status === "active";

          return (
            <span
              style={{
                color: isActive ? "#15803d" : "#b91c1c",
                fontWeight: 700,
                textTransform: "capitalize",
              }}
            >
              {status || "-"}
            </span>
          );
        },
      },
    },
    {
      name: "SL",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return <p>{parseFloat(tableMeta.rowIndex) + 1}</p>;
        },
      },
    },
    { name: "prod_code", label: "Product code", options: { filter: true, sort: true } },
    { name: "prod_cat_name", label: "Category", options: { filter: true, sort: true } },
    { name: "prod_brand_name", label: "Brand", options: { filter: true, sort: true } },
    { name: "prod_name", label: "Product", options: { filter: true, sort: true } },
    { name: "prod_unit_name", label: "Unit", options: { filter: true, sort: true } },
    {
      name: "actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return <ActionOptions value={value} rowIndex={tableMeta.rowIndex} rowData={tableMeta.rowData} />;
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: isMainBranchUser ? "multiple" : "none",
    selectableRowsHeader: isMainBranchUser,
    selectableRowsHideCheckboxes: !isMainBranchUser,
    rowsSelected: selectedProductIndexes,
    onRowsSelect: (currentRowsSelected, allRowsSelected) => {
      const selectedIndexes = allRowsSelected
        .map((row) => row?.dataIndex)
        .filter((index) => typeof index === "number");
      const pickedRows = selectedIndexes.map((index) => products[index]).filter(Boolean);
      selectedProductIndexesSet(selectedIndexes);
      selectedProductRowsSet(pickedRows);
    },
    customToolbar: () => {
      return (
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetAppIcon />}
          onClick={handleBarcodeModalOpen}
          style={{ marginRight: "10px" }}
        >
          Bar Code
        </Button>
      );
    },
  };

  return (
    <div className={classes.root}>
      <Snackbar open={successMsg.open} autoHideDuration={10000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {successMsg.msg}
        </Alert>
      </Snackbar>

      {/* Barcode Modal */}
      <Modal
        open={barcodeModal}
        onClose={handleBarcodeModalClose}
        center
        styles={{
          modal: {
            width: "80%",
            maxHeight: "90vh",
            overflowY: "auto",
          },
        }}
      >
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <h2>Product Barcodes</h2>
            <div>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PrintIcon />}
                onClick={printBarcodes}
                style={{ marginRight: "10px" }}
              >
                Print
              </Button>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<GetAppIcon />}
                onClick={downloadBarcodes}
              >
                Download
              </Button>
            </div>
          </div>

          <div
            id="barcode-container"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: "20px",
            }}
          >
            {selectedProducts.map((product, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #eee",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                  {product.prod_name}
                </div>
                <Barcode
                  value={String(product.prod_id).padStart(7, '0')}
                  width={1.5}
                  height={50}
                  fontSize={12}
                />
                <div style={{ marginTop: "5px" }}>{product.prod_code}</div>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      <Paper className={classes.paper} style={{ marginTop: "-15px" }}>
        <h2 className={classes.pageEntryLabel}>Product Entry</h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              disabled
              className={classes.fullWidth}
              value={productCode}
              label="Product code"
              variant="outlined"
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            {authInfo.role != "user" && (
              <a className={classes.plusLink} onClick={() => catMSet(true)}>+</a>
            )}
            <Autocomplete
              style={{ width: "100%" }}
              options={categories}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option?.prod_cat_name ?? ""}
              value={selectedCategory}
              onChange={(event, selectedObj) => selectedCategorySet(selectedObj)}
              renderInput={(params) => (
                <TextField
                  inputRef={catRef}
                  onKeyDown={(e) => e.key === "Enter" && brandRef.current.focus()}
                  {...params}
                  label="Choose a category"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            <a className={classes.plusLink} onClick={() => brandMSet(true)}>+</a>
            <Autocomplete
              style={{ width: "100%" }}
              options={brands}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option?.prod_brand_name ?? ""}
              value={selectedBrand}
              onChange={(event, selectedObj) => selectedBrandSet(selectedObj)}
              renderInput={(params) => (
                <TextField
                  inputRef={brandRef}
                  onKeyDown={(e) => e.key === "Enter" && colorRef.current.focus()}
                  {...params}
                  label="Choose a brand"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            <a className={classes.plusLink} onClick={() => colorMSet(true)}>+</a>
            <Autocomplete
              style={{ width: "100%" }}
              options={colors}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option?.prod_color_name ?? ""}
              value={selectedColor}
              onChange={(event, selectedObj) => selectedColorSet(selectedObj)}
              renderInput={(params) => (
                <TextField
                  inputRef={colorRef}
                  onKeyDown={(e) => e.key === "Enter" && prodNameRef.current.focus()}
                  {...params}
                  label="Choose a Country"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            {authInfo.role != "user" && (
              <a className={classes.plusLink} onClick={() => prodMSet(true)}>+</a>
            )}
            <Autocomplete
              style={{ width: "100%" }}
              options={prodNames}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option?.prod_name ?? ""}
              value={selectedProdName}
              onChange={(event, selectedObj) => selectedProdNameSet(selectedObj)}
              renderInput={(params) => (
                <TextField
                  inputRef={prodNameRef}
                  onKeyDown={(e) => e.key === "Enter" && unitNameRef.current.focus()}
                  {...params}
                  label="Choose a product name"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            <a className={classes.plusLink} onClick={() => unitMSet(true)}>+</a>
            <Autocomplete
              style={{ width: "100%" }}
              options={units}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option?.prod_unit_name ?? ""}
              value={selectedUnit}
              onChange={(event, selectedObj) => selectedUnitSet(selectedObj)}
              renderInput={(params) => (
                <TextField
                  inputRef={unitNameRef}
                  onKeyDown={(e) => e.key === "Enter" && reOrderLevelRef.current.focus()}
                  {...params}
                  label="Unit Name"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              onKeyDown={(e) => e.key === "Enter" && saveFormActionRef.current.click()}
              inputRef={reOrderLevelRef}
              className={classes.fullWidth}
              value={prod_re_order_lebel}
              label="Re-order level"
              type="number"
              variant="outlined"
              size="small"
              onChange={(e) => prod_re_order_lebel_set(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={prod_is_service}
                  onChange={(e) => prod_is_service_set(e.target.checked)}
                />
              }
              label="Service Type?"
              style={{ color: "#0f7e77" }}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Button
            style={{ marginTop: "25px" }}
            buttonRef={saveFormActionRef}
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={saveFormAction}
          >
            Save
          </Button>
        </Grid>
      </Paper>

      {loadingList ? <b>Loading...</b> : null}
      {!loadingList && productListError ? (
        <Paper className={classes.paper} style={{ marginTop: "20px", color: "#b91c1c", fontWeight: 600 }}>
          {productListError}
        </Paper>
      ) : null}
      {!loadingList && !productListError ? (
        <Paper className={classes.paper} style={{ marginTop: "20px" }}>
          {isMainBranchUser ? (
            <Grid container spacing={2} style={{ marginBottom: "10px" }}>
              <Grid item xs={12} sm={4}>
                <Autocomplete
                  options={branches}
                  size="small"
                  value={selectedBranch}
                  getOptionLabel={(option) => option?.branch_name ?? ""}
                  onChange={(event, selectedObj) => selectedBranchSet(selectedObj)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Choose target branch"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled={loadingBranchSend || selectedProductRows.length === 0}
                    onClick={sendSelectedProductsToBranch}
                  >
                    {loadingBranchSend ? "Sending..." : `Send Selected (${selectedProductRows.length})`}
                  </Button>
                </div>
              </Grid>
            </Grid>
          ) : null}
          <MUIDataTable
            key={productTableKey}
            title={"Product List"}
            data={products}
            columns={columns}
            options={options}
          />
        </Paper>
      ) : null}

      {/* Category Modal */}
      <Modal open={catM} onClose={() => catMSet(false)} center>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            style={{ marginTop: "10px" }}
            className={classes.fullWidth}
            value={prod_cat_name}
            onChange={(e) => prod_cat_name_set(e.target.value)}
            label="Category Name"
            variant="outlined"
            size="small"
            onKeyDown={(e) => e.key === "Enter" && saveCateAction()}
          />
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            disabled={catAction}
            startIcon={<SaveIcon />}
            onClick={saveCateAction}
          >
            Save
          </Button>
        </Grid>
      </Modal>

      {/* Brand Modal */}
      <Modal open={brandM} onClose={() => brandMSet(false)} center>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            style={{ marginTop: "10px" }}
            className={classes.fullWidth}
            value={prod_brand_name}
            onChange={(e) => prod_brand_name_set(e.target.value)}
            label="Brand Name"
            variant="outlined"
            size="small"
            onKeyDown={(e) => e.key === "Enter" && saveBrandAction()}
          />
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            disabled={brandAction}
            startIcon={<SaveIcon />}
            onClick={saveBrandAction}
          >
            Save
          </Button>
        </Grid>
      </Modal>

      {/* Color Modal */}
      <Modal open={colorM} onClose={() => colorMSet(false)} center>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            style={{ marginTop: "10px" }}
            className={classes.fullWidth}
            value={prod_color_name}
            onChange={(e) => prod_color_name_set(e.target.value)}
            label="Country Name"
            variant="outlined"
            size="small"
            onKeyDown={(e) => e.key === "Enter" && saveColorAction()}
          />
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            disabled={colorAction}
            startIcon={<SaveIcon />}
            onClick={saveColorAction}
          >
            Save
          </Button>
        </Grid>
      </Modal>

      {/* Unit Modal */}
      <Modal open={unitM} onClose={() => unitMSet(false)} center>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            className={classes.fullWidth}
            value={prod_unit_name}
            onChange={(e) => prod_unit_name_set(e.target.value)}
            label="Unit Name"
            variant="outlined"
            size="small"
            onKeyDown={(e) => e.key === "Enter" && saveUnitAction()}
          />

          <Button
            variant="contained"
            color="primary"
            size="small"
            disabled={unitAction}
            startIcon={<SaveIcon />}
            onClick={saveUnitAction}
          >
            Save
          </Button>
        </Grid>
      </Modal>


      {/* Product Name Modal */}
      <Modal open={prodM} onClose={() => prodMSet(false)} center>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            style={{ marginTop: "10px" }}
            className={classes.fullWidth}
            value={prod_name}
            onChange={(e) => prod_name_set(e.target.value)}
            label="Product Name"
            variant="outlined"
            size="small"
            onKeyDown={(e) => e.key === "Enter" && saveProdAction()}
          />
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            disabled={prodNameAction}
            startIcon={<SaveIcon />}
            onClick={saveProdAction}
          >
            Save
          </Button>
        </Grid>
      </Modal>

      {/* Unit Modal */}

    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  pageEntryLabel: {
    color: "#7754cc",
    margin: "0px",
    padding: "0px",
    marginTop: "-11px",
    textAlign: "left",
    marginBottom: "5px",
  },
  fullWidth: {
    width: "100%",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
    cursor: "pointer",
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
    createdProdName: state.createdProdNameReducer,
    updatedProdName: state.updatedProdNameReducer,
    prodNameDisableRestoreAction: state.disableRestoreProdNameReducer,
    createdCategory: state.createdCategoryReducer,
    updatedCategory: state.updatedCategoryReducer,
    createBrand: state.createdBrandReducer,
    updateBrand: state.updatedBrandReducer,
    createdColor: state.createdColorReducer,
    createdUnit: state.createdUnitReducer,
    updatedUnit: state.updatedUnitReducer,
    updatedColor: state.updatedColorReducer,
    createdProduct: state.createdProductReducer,
    updatedProduct: state.updatedProductReducer,
    productCodeGet: state.productCodeReducer,
    productDisableRestoreAction: state.disableRestoreProductReducer,
  };
};
export default connect(mapStateToPops, {
  currentRouteSet,
  updatedProductSet,
  disableRestoreProductSet,
  createdProductSet,
  createdUnitSet,
  updatedUnitSet,
})(ProductsManage);
